export default __webpack_public_path__ + "static/intelligent-automation-1--mobile-b252e3693e3ba398e28cbdb4b20f5a6d.png";